import { BehaviorSubject, Observable } from 'rxjs';
import { FilterKeyEnum } from './filter-keys';

class FilterService<T extends object> {
  private filter$: BehaviorSubject<T>;
  private storageKey: string;

  constructor(key: string) {
    this.storageKey = key;
    const saved = this.loadFromStorage();
    this.filter$ = new BehaviorSubject<T>(saved ?? {} as T);
  }

  observe(): Observable<T | null> {
    return this.filter$.asObservable();
  }

  get(): T  {
    return this.filter$.getValue() ?? {} as T;
  }

  private set(filter: T): void {
    this.saveToStorage(filter);
    this.filter$.next(filter);
  }

  patch(partial: Partial<T>): void {
    const current = this.get();
    const updated = { ...current, ...partial };
    this.set(updated);
  }

  clear(value?: Partial<T>): void {
    this.removeFromStorage();
    if(value){
      this.filter$.next({...value} as T);
      return;
    }
    this.filter$.next({} as T);
  }
  private saveToStorage(value: T): void {
    localStorage.setItem(this.storageKey, JSON.stringify(value));
  }

  private loadFromStorage(): T | null {
    const raw = localStorage.getItem(this.storageKey);
    return raw ? JSON.parse(raw) as T : null;
  }

  private removeFromStorage(): void {
    localStorage.removeItem(this.storageKey);
  }
}

export function provideFilter<T extends object> (key: FilterKeyEnum) {
  return new FilterService<T>(key);
}
